import {
  BlankPage,
  HubPage,
  HubDevicePage,
  ProductDetailPage,
  DeviceDetailPage,
  ShoppingCartPage,
  HomepagePage,
  NotFoundPage,
} from '@vfit/consumer/components';
import { usePage } from '@vfit/consumer/data-access';

export default function Layout() {
  const { page } = usePage() || {};
  const params = page?.params;
  switch (params?.layout) {
    case 'HUB':
      if (params?.elements?.apiDeviceList) {
        return <HubDevicePage page={page} />;
      }
      return <HubPage page={page} />;
    case 'BLANK':
      if (params?.elements?.heroslider) {
        return <HomepagePage page={page} />;
      }
      return <BlankPage page={page} />;
    case 'PRODUCT_DETAIL':
      if (params?.elements?.apiDeviceList) {
        return <DeviceDetailPage page={page} />;
      }
      return <ProductDetailPage page={page} />;
    case 'SHOPPING_CART':
      return <ShoppingCartPage />;
    default:
      break;
  }
  return <NotFoundPage page={page} />;
}
